<template>
  <div>
    <div v-if="!nameConfirmed">
      <h1>Boodschapp</h1>
      <p>Wat is je naam?</p>
      <v-container fluid>
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              name="input-1"
              label="Naam"
              id="testing"
              v-model="name"
            ></v-text-field>
            <v-btn @click="nameConfirmed = true" color="blue">Bevestigen</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div v-if="nameConfirmed">
      <v-container fluid>
        <v-layout row>
          <v-flex xs12>
            <h1 class="authentication__title">Boodschapp</h1>
            <!--<h2>Leuk je weer te zien!</h2>-->
            <p>Hoi {{ name }}, voordat je kan beginnen moet je een account aanmaken. Hiervoor heb je een e-mailadres en een wachtwoord nodig.</p>
          </v-flex>
        </v-layout>
      </v-container>
      <credentials
        :emailAddress="emailAddress"
        :password="password"
        @emailaddressEntered="emailaddressEntered"
        @passwordEntered="passwordEntered"
        @confirmed="confirmedRegister"
        />
    </div>
  </div>
</template>

<script>
  import Credentials from '../../organisms/Credentials'
  // import { UsersApi } from '@/api'
  import firebase from 'firebase'

  export default {
    name: 'register',
    data () {
      return {
        name: '',
        emailAddress: '',
        password: '',
        nameConfirmed: false
      }
    },
    components: {
      Credentials
    },
    methods: {
      emailaddressEntered (emailAddress) {
        this.emailAddress = emailAddress
      },
      passwordEntered (password) {
        this.password = password
      },
      confirmedRegister () {
        // UsersApi.registerUser(this.emailAddress, this.password)
        //   .then(() => console.log('success'))
        //   .catch(error => console.log(error))
        firebase.auth().createUserWithEmailAndPassword(this.emailAddress, this.password)
          .then(response => {
            console.log(response.providerData)
            // this.loginUser(response.providerData)
          })
          .catch(function (error) {
            // Handle Errors here.
            let errorCode = error.code
            let errorMessage = error.message
            console.log(errorCode, errorMessage)
          })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Register.vue?1910f3d5